<template>
  <div>
    <sui-dimmer v-if="fetching || isFetchingUserData" active>
      <sui-loader />
    </sui-dimmer>
    <p>
      <sui-label><sui-flag :name="regionCode && regionCode.toLowerCase()" /> {{regionName}} </sui-label>
      <a is="sui-label" v-for="keyword in keywords" :key="keyword" :link="true" @click="openUrl(`https://www.youtube.com/results?search_query=${keyword}`)">{{keyword}} </a>
    </p>
    <p>
      <sui-label> <sui-icon name="calendar" />{{ formatDateTime(startDate) }} &mdash; <sui-icon name="calendar" />{{ formatDateTime(endDate) }} </sui-label>
    </p>
    <sui-segment v-if="videos && videos.length > 0">
      <sui-card-group :items-per-row="3">
        <sui-card v-for="video in videos" :key="video.id">
          <sui-image :src="video.thumbnail" />
          <sui-card-content>
            <sui-card-meta>{{formatDateTime(video.created)}}
              <sui-icon class="right floated" :link="true" name="external alternate" @click="openUrl(video.url)"></sui-icon>
            </sui-card-meta>
            <sui-card-description>{{video.title}}</sui-card-description>            
          </sui-card-content>
        </sui-card>
      </sui-card-group>
    </sui-segment>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/firestore';
import { mapState } from 'vuex';
import regionData from 'country-region-data';

export default {
  data () {
    return {
      event: undefined,
      fetching: false,
    };
  },
  computed: {
    videos () {
      return this.event && this.event.videos;
    },
    keywords () {
      return this.event && this.event.keywords;
    },
    regionCode () {
      return this.event && this.event.regionCode;
    },
    startDate () {
      return this.event && this.event.startDate && this.event.startDate.toDate();
    },
    endDate () {
      return this.event && this.event.endDate && this.event.endDate.toDate();
    },
    regionName () {
      const { regionCode } = this;
      const region = regionData.find(r => r.countryShortCode === regionCode);
      return (region && region.countryName) || regionCode;
    },
    ...mapState([
      'isAdmin',
      'isFetchingUserData',
    ]),
  },
  mounted() {
    const eventId = this.$route.params.id;
    this.event = this.$store.getters.getEventById(eventId);
    if (this.event === undefined) {
      this.fetchEvent(eventId);
    }
  },
  methods: {
    async fetchEvent(id) {
      this.fetching = true;
      const db = firebase.firestore();
      this.event = (await db.collection('event_splashes').doc(id).get()).data();
      this.fetching = false;
    },
    formatDateTime (date) {
      return (new Date(date)).toLocaleString();
    },
    openUrl (url) {
      window.open(url, '_blank');
    },
  },
}
</script>

<style>

</style>